import { forwardRef, ReactNode } from 'react'
import {
  Label as ThemeUILabel,
  LabelProps as ThemeUILabelProps,
} from 'theme-ui'

export type LabelProps = ThemeUILabelProps & {
  children: ReactNode
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ children, ...rest }, ref) => (
    <ThemeUILabel ref={ref as any} {...rest}>
      {children}
    </ThemeUILabel>
  )
)
